var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyGbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -15.5,
    width: 1827,
    height: 59,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 43.1153,
    height: 28.6785,
    rx: 5.38875,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 44,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0V28.6785H35.6153V0H-7.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0V28.6785H35.6153V0H-7.5Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0L35.6153 28.6785ZM35.6153 0L-7.5 28.6785Z",
    fill: "#000008"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0L35.6153 28.6785M35.6153 0L-7.5 28.6785",
    stroke: "white",
    strokeWidth: 4.31153
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 44,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0577 14.3393H35.6153V28.6785L14.0577 14.3393ZM14.0577 14.3393V28.6785H-7.5L14.0577 14.3393ZM14.0577 14.3393H-7.5V0L14.0577 14.3393ZM14.0577 14.3393V0H35.6153L14.0577 14.3393Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0L35.6153 28.6785ZM35.6153 0L-7.5 28.6785Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0L35.6153 28.6785M35.6153 0L-7.5 28.6785",
    stroke: "#C8102E",
    strokeWidth: 2.87435
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0577 0V28.6785ZM-7.5 14.3393H35.6153Z",
    fill: "#000008"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0577 0V28.6785M-7.5 14.3393H35.6153",
    stroke: "white",
    strokeWidth: 7.18589
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0577 0V28.6785ZM-7.5 14.3393H35.6153Z",
    fill: "#000008"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0577 0V28.6785M-7.5 14.3393H35.6153",
    stroke: "#C8102E",
    strokeWidth: 4.31153
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 43.1153,
    height: 28.6785,
    rx: 5.38875,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyGbp);
export default __webpack_public_path__ + "static/media/Currency=GBP.fc7c47ab09c3ea5d928dbb57371b5c0c.svg";
export { ForwardRef as ReactComponent };